import { useEffect, useState } from "react";
import './profile.css';
import { useGetBusinessProfileMutation } from "../api/chatApi";
import { useSelector } from "react-redux";
import { formatePhoneNumber } from "../../../utils/helpers";

const Profile = ({onClose}) => {
  const { session } = useSelector((state) => state.auth);
  const [businessProfileData, setBusinessProfileData] = useState(null);
  const [deleteImage, setDeleteImage] = useState("/delete.png");
  const [images, setImages] = useState({
    cover: {
      file: null,
      preview: "/cover-picture.avif",
    },
    profile: {
      file: null,
      preview: "/avatar.jpeg",
    }
  });
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    address: "",
    category: "",
    website: "",
    email: "",
    phone: ""
  });

  const [getBusinessProfileApi] = useGetBusinessProfileMutation();
  
  const handleFileSelect = (e) => {
    const { files, dataset } = e.target;
    const type = dataset.type;
    const file = files?.[0];

    if (!file || !type) return;

    const preview = URL.createObjectURL(file);

    setImages((prev) => ({
      ...prev,
      [type]: {
        file, preview,
      },
    }));
    
    e.target.value = '';
  }

  const handleDeleteImage = (e) => {

  }

  const handleChange = (e) => {
    const {name, value} = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const handleBrowseClickForCoverPicture = () => document.getElementById("fileInput-1").click();
  const handleBrowseClickForProfilePicture = () => document.getElementById("fileInput-2").click();

  const fetchBusinessProfile = async () => {
    const userId = session?.user_id;
    try {
        const response = await getBusinessProfileApi({user_id: userId}).unwrap();
        if (response.success) {
            setBusinessProfileData(response.data);
        }
    } catch (error) {
          
    }
  }

  useEffect(() => {
    fetchBusinessProfile();
  }, []);

  return (
    <div className="tyn-main tyn-content-inner" id="tynMain">
      <div id="container">
        <div className="tyn-profile">

          <div className="tyn-profile-head">
            <div className='tyn-profile-close' onClick={onClose}>
                <img className="close-icon" src="/close.png" alt=""/>
            </div>
            <div className="tyn-profile-cover">
              <img
                className="tyn-profile-cover-image"
                src={images.cover.preview}
                alt="Cover"
              />

              {images.cover.file && 
                <div className="trash-div" onClick={handleDeleteImage}>
                  <img src={deleteImage} alt="" />
                </div>
              }

              <input
                id="fileInput-1"
                type="file"
                name='imagefile'
                data-type="cover"
                onChange={handleFileSelect}
                accept="image/*"
                style={{ display: "none" }}
              />

              <div className="tyn-profile-cover-btn">
                <button
                  className="edit-btn"
                  type="button"
                  onClick={handleBrowseClickForCoverPicture}
                >
                    Browse
                </button>
              </div>

            </div>

            <div className="tyn-profile-info">
              <div className="tyn-media-group align-items-start">
                <div className="tyn-media tyn-profile-avatar">
                  <img src={images.profile.preview} alt="Profile" />

                  {images.profile.file && 
                    <div className="trash-div">
                      <img src={deleteImage} alt="" />
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>

          <div className="tyn-profile-nav">
            <input
              id="fileInput-2"
              type="file"
              name='imagefile'
              data-type="profile"
              onChange={handleFileSelect}
              accept="image/*"
              style={{ display: "none" }}
            />
            
            <button
              className="edit-btn"
              onClick={handleBrowseClickForProfilePicture}
            >
                Edit Profile
            </button>
          </div>

          <div className="tyn-profile-details">
            <div className="tab-content">
              <div
                className="tab-pane"
                id="profile-edit"
                role="tabpanel"
              >
                <div className="row gy-5">

                  <div className="col-12">
                    <div className="row gy-4">
                      <h4>Business Information</h4>

                        <div className="col-lg-9">
                            <div className="form-group">
                              <label className="form-label">Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="push_name"
                                value={session?.push_name}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="form-group">
                              <label className="form-label">Description</label>
                              <input
                                type="text"
                                className="form-control"
                                name="description"
                                value={businessProfileData?.description}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="form-group">
                              <label className="form-label">Address</label>
                              <input
                                type="text"
                                className="form-control"
                                name="address"
                                value={businessProfileData?.address}
                                onChange={handleChange}
                              />
                            </div>

                            <div className="form-group">
                              <label className="form-label">Category</label>
                              <input
                                type="text"
                                className="form-control"
                                name="category"
                                value={businessProfileData?.category}
                                onChange={handleChange}
                              />
                            </div>

                            {/* <div className="form-group">
                              <label className="form-label">Category</label>
                              <input
                                type="text"
                                className="form-control"
                                value={businessProfileData?.category}
                              />
                            </div> */}

                            <div className="form-group">
                              <label className="form-label">Website</label>
                              <input
                                type="text"
                                className="form-control"
                                name="website"
                                value={businessProfileData?.website}
                                onChange={handleChange}
                              />
                            </div>
                        </div>

                        <div className="col-lg-9">
                          <h4>Contact Information</h4>
                          <div className="form-group">
                            <label className="form-label">Email</label>
                            <input
                              type="text"
                              className="form-control"
                              name="email"
                              value={businessProfileData?.email}
                              onChange={handleChange}
                            />
                          </div>

                          <div className="col-lg-6">
                            <div className="form-group">
                            <label className="form-label">
                                Phone Number
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                name="phone"
                                value={formatePhoneNumber(businessProfileData?.wid)}
                                onChange={handleChange}
                            />
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>

                  <button
                    className="update-btn"
                  >
                    Update
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Profile;
